export const mkPreparedData = (obj, hasDiff) => {
  if (hasDiff) {
    return { after: JSON.stringify(obj.after), before: JSON.stringify(obj.before) };
  }
  return JSON.stringify(obj);
};
